import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useRecoilValue } from 'recoil';
import { showSensitiveInfoState } from '~/state/atoms/viewerAtoms';

interface SensitiveInfoTypographyProps {
    children: ReactNode;
    sx?: object;
}

const SensitiveInfoTypography = ({
    children,
    sx,
}: SensitiveInfoTypographyProps) => {
    const showSensitiveInfo = useRecoilValue(showSensitiveInfoState);
    const isSensitive = showSensitiveInfo ? 'false' : 'true';
    return (
        <Box
            component="span"
            sx={{
                font: 'inherit',
                color: 'inherit',
                filter: showSensitiveInfo ? 'none' : 'blur(0.5rem)',
                userSelect: showSensitiveInfo ? 'auto' : 'none',
                ...sx,
            }}
            data-testid="sensitive-info-typography"
            data-sensitive={isSensitive}
        >
            {children}
        </Box>
    );
};

export default SensitiveInfoTypography;
